<div
  [ngClass]="{
    'preview-image-message-out': messageSource,
    'preview-image-message-in': !messageSource
  }"
  #divElement
  >
  @if (messageSource) {
    <app-read-receipt class="read-receipt" [messageStatus]="content['messageStatus']"></app-read-receipt>
  }
  <img
    class="preview-image-display"
    [src]="this.sanitization.bypassSecurityTrustUrl(content['src'])"
    [(ngModel)]="content['src']"
    #imagePreview="ngModel"
    #imgElement
    />
    <div class="preview-message-caption">{{ previewCaption }}</div>
    <div (click)="previewImage(imagePreview.model)" class="overlay"></div>
    <div (click)="previewImage(imagePreview.model)" class="image">
      <img src='../../../../../../../assets/svg/eye-ON.svg' />
    </div>
  </div>

  <ng-template #previewImageModule>
    <div class="preview-image-container">
      <div class="preview-image-header">
        <div class="preview-image-caption">
          <div class="text">{{ previewCaption }}</div>
        </div>
        <button class="preview-image-closeBtn" (click)="onClosePreview()"></button>
      </div>
      <div class="preview-image-body">
        <img class="preview-image" [src]="previewImageSrc" />
      </div>
    </div>
  </ng-template>
